import { useContext } from 'react';
import { AppContext } from '../containers/App/context';

const useHistory = () => {
  const { history } = useContext(AppContext);
  return history;
};

export default useHistory;
